import * as React from 'react';
import Tooltip from '@mui/material/Tooltip';
import WarningIcon from '@mui/icons-material/Warning';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

export default function WidgetTruncatedWarningIcon(): React.ReactElement {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                zIndex: 1,
            }}
        >
            <Tooltip title={t('widget.editedWidgetTruncatedWarning')}>
                <WarningIcon sx={{ color: 'red' }} />
            </Tooltip>
        </Box>
    );
}
